var If = function If(_ref) {
  var children = _ref.children,
    condition = _ref.condition,
    _ref$renderIf = _ref.renderIf,
    renderIf = _ref$renderIf === void 0 ? null : _ref$renderIf,
    _ref$renderElse = _ref.renderElse,
    renderElse = _ref$renderElse === void 0 ? null : _ref$renderElse;
  var ifElement = children ? children : renderIf;
  return condition ? ifElement : renderElse;
};
export default If;